import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface CheckSalStatusFnPayload {
    magicLinkGrant: string;
}

export type CheckSalStatusFn = (payload: CheckSalStatusFnPayload) => Promise<{
    status:
        | 'SUB_UNCLAIMED_EMAIL_AVAILABLE'
        | 'SUB_UNCLAIMED_EMAIL_AVAILABLE_SIGNIN_TO_REUSE_EMAIL'
        | 'SUB_UNCLAIMED_NO_EMAIL'
        | 'SUB_UNCLAIMED_EMAIL_TAKEN'
        | 'SUB_CLAIMED';
    email?: string;
    grant?: string;
}>;

export function initCheckSalStatusFn({
    dependencies: { clientSdk },
}: DomainInitPayload): CheckSalStatusFn {
    return async ({ magicLinkGrant }: CheckSalStatusFnPayload) => {
        try {
            const response =
                await clientSdk.user.checkSalStatus(magicLinkGrant);
            if ('subscriptionUnclaimedEmailAvailable' in response) {
                return {
                    status: 'SUB_UNCLAIMED_EMAIL_AVAILABLE',
                    email: response.subscriptionUnclaimedEmailAvailable
                        .rosEmail,
                };
            } else if (
                /**
                 * TODO:
                 * ClientSdk is showing this no longer exists on model, we need to check and see
                 * if we should remove this
                 */
                'subscriptionUnclaimedEmailAvailableUnauthorized' in
                (response as any)
            ) {
                return {
                    status: 'SUB_UNCLAIMED_EMAIL_AVAILABLE_SIGNIN_TO_REUSE_EMAIL',
                    email: (response as any).subscriptionUnclaimedEmailAvailable
                        .rosEmail,
                };
            } else if ('subscriptionUnclaimedNoEmail' in response) {
                return {
                    status: 'SUB_UNCLAIMED_NO_EMAIL',
                };
            } else if ('subscriptionUnclaimedEmailTaken' in response) {
                return {
                    status: 'SUB_UNCLAIMED_EMAIL_TAKEN',
                };
            } else if ('subscriptionClaimed' in response) {
                return {
                    status: 'SUB_CLAIMED',
                    grant: response.subscriptionClaimed.grant,
                };
            } else {
                throw new Error('INVALID_SAL_STATUS');
            }
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
